import React from "react";
import VaultSecureLogo from "./VaultSecureLogo";

export default function Logo({ className = "" }) {
  return (
    <div className={`d-flex align-items-center logo-container ${className}`} style={{ gap: '0.5rem' }}>
      <VaultSecureLogo color="currentColor" />
      <h1 className="mb-0 fw-bold fs-5 logo-text">VaultSecure</h1>
    </div>
  );
}
